<template>
  <div>
    <dropdown id="draft-dropdown">
      <router-link
        class="btn btn-info"
        :to="{name: 'AnchorPage', params: { uuid: uuid }, query: {draft: 'true'}}"
        target="_blank">Preview Changes</router-link>
      <btn
        class="dropdown-toggle btn btn-info"
        aria-label="Open draft page options"
      >
        <span class="caret" />
      </btn>
      <template slot="dropdown">
        <li>
          <a role="button" @click="discardDraft()">Discard Changes</a>
        </li>
        <li>
          <a role="button" @click="saveDraft()">Publish Changes</a>
        </li>
      </template>
    </dropdown>
  </div>
</template>

<script>
import { Dropdown, MessageBox, Btn } from 'uiv'

export default {
  name: 'DraftActions',
  components: { Dropdown, Btn },
  data() {
    return {}
  },
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  methods: {
    async saveDraft() {
      try {
        await MessageBox.confirm({
          title: 'Publish Changes',
          content: `<p class="text-danger"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Are you sure you want to save unpublished changes? They will become public.</p>`,
          html: true
        })
        this.$emit('savedraft')
      } catch {}
    },
    async discardDraft() {
      try {
        await MessageBox.confirm({
          title: 'Discard Changes',
          content: `<p class="text-danger"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Are you sure you want to discard unpublished changes? They will be permanently deleted.</p>`,
          html: true
        })
        this.$emit('discarddraft')
      } catch {}
    },
    previewDraft() {
      this.$emit('previewdraft')
    }
  },
}
</script>

<style lang="less" scoped>
  @btnBgColor: #3f0061;
  .dropdown-toggle {
    margin-right: 0.5em;
  }
  .btn-info, .dropdown-toggle.btn-info {
    background-color: #3f0061;
    border-color: #030005;
    &:hover {
      background-color: darken(@btnBgColor, 10%)
    }
  }
  .open {
   .dropdown-toggle, .dropdown-toggle:focus, .dropdown-toggle:active, .dropdown-toggle:hover {
      background-color: lighten(@btnBgColor, 20%);
      border-color: lighten(@btnBgColor, 20%);
    }
  }
</style>
